export const PROJECT_TRY_NOW = {
    title: "TryNow is a try-before-you-buy software for shoppers and Shopify brands.",
    text: [
        "TryNow converts the customer's living room into the fitting room and authorises the credit card, tracks the SKUs, and captures payment once the customer has decided what they are going to keep, enabling businesses to improve their sales and productivity.",
        "TryNow integrates seamlessly with Shopify checkout and with a Merchant's fulfilment and reverses logistics operations and does not introduce any risk for fraud or shopper non-payment.",
    ],
    image: "https://newsoft-ns.com/media/trynow_case/trynow_team.webp",
}

export const PROJECT_ORBIT = {
    title: "Orbit is a recruitment platform designed for freelance recruiters.",
    text: [
        "The system enables companies to post job vacancies which are then accessed by recruiters. Recruiters, in turn, identify and work with potential candidates for job vacancies. Once a candidate is approved by the recruiter, the candidate moves to the company's internal hiring process. Upon successful candidate approval by the company, the recruiter receives a bonus for their work.",
        "The project started with a four-page document outlining the client's product vision. Newsoft team worked on the project from scratch and created more features than initially planned. They developed the database, backend, and frontend, and designed the project. The project has progressed to a stage where multiple companies and recruiters are using the system.",
    ],
    image: "https://newsoft-ns.com/media/orbit_case/orbit_project.webp",
}

export const PROJECT_GAMETECH = {
    title: "Gametech is a gaming platform",
    text: [
        "Gametech is a gaming platform enables land-based casinos, consumer brands and media company partners to leverage their own branded online gambling presence with a full suite of powerful marketing and analytics tools. ",
        "Gaming platform built from the ground up to be able to get to market and deploy new versions quickly and be adaptable.",
    ],
    image: "https://newsoft-ns.com/media/gametech_case/PedNet_project+copy.webp",
}

export const PROJECT_QUARKWORKS = {
    title: "QuarkWorks is a software engineering and digital product design firm.",
    text: [
        "They partner with startups and enterprise companies that are working on new products and features. They specialize in native mobile apps, web dev, e-commerce, UI/UX design, branding, and more!",
        "Whether your business is established or is a budding startup, Quarkworks work where you are to bring your vision into reality.",
    ]
}

export const PROJECT_HELLO = {
    title: "Hello is an app that connects you with people who share your interests. ",
    text: [
        "In general, this is a social network based on interests, you can set your interests in the application, build your own communities and chat with people.",
        "This app was dreamt up by well-known social pioneer Orkut Buyukkokten. Along with a small group of ex-Google engineers, he set out to change how the world does social. Headquartered in San Francisco and with offices in Mountain View, the amazing hello team continues to grow. ",
    ],
    image: "https://newsoft-ns.com/media/hello_case/hello_project.webp",
}

export const PROJECT_CRAFT = {
    title: "Craft Ventures is a growth fund dedicated to the craft of building great companies. Comprised entrepreneurs and operators.",
    text: [
        "Together with Craft Ventures we built a SaaS analytics platform for businesses. The user took his Excel sheet with data on earnings, expenses, and the site analyzed it all very quickly, providing the user with all the analysis with graphs. ",
        "We made a fully customized functionality about how things are going in business in general. The user had his customized dashboards and graphs. Mostly it is visualization and analysis of excel data.",
    ],
    image: "https://newsoft-ns.com/media/craft_case/craft_project.webp",
}

export const PROJECT_PEDNET = {
    title: "PedNet is a grassroots advocacy organization focused on transportation equity.",
    text: [
        "Their mission is to provide walking, biking, and transit solutions to meet people’s everyday transportation needs. \n\n Together with PedNet we have developed a mobile application for Android and iOS that allows people to interact with local authorities in America and report problems related to road safety, pedestrians, and cyclists.",
        "If residents saw any problems, problems, or obstacles for cyclists, drivers and pedestrians, they could put a mark on the map, fill out the form in the application and send this request. This organization reviews all these problems and interacts with the authorities in Columbia, Missouri.",
    ],
    image: "https://newsoft-ns.com/media/pednet_case/pednet_project.webp",
}
